var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('span',{staticClass:"message-wrap",on:{"click":_vm.cb}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }